import {Loading} from "@carbon/react";
import { useTranslation } from "react-i18next";

const Index = ({panel}) => {
    const { t } = useTranslation();
    return (
        <div id={`panel_placeholder-${panel.id}-${panel.chart_type}`} className='panel-placeholder'>
            <h2>{t("panels.loadingChart")}</h2>
            <h3>{panel.name}</h3>
            <Loading
                description={t("common.loading")} withOverlay={false}
            />
        </div>
    )
}
export default Index
